import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Location } from 'src/app/core/models/project/location.model';
import { Property } from 'src/app/core/models/project/property.model';
import { ProjectService } from 'src/app/modules/project/services/project.service';
import { DisplayPropertyParams } from '../display-property/display-property.component';

@Component({
  selector: 'app-display-window',
  templateUrl: './display-window.component.html',
  styleUrl: './display-window.component.scss'
})
export class DisplayWindowComponent implements OnDestroy, OnInit {
    @Input({required:true}) location: Location;
    @Input({required:true}) displaySize: 'minimal' | 'large';
    @Input({required:true}) propToDisplay: DisplayPropertyParams;

    Property = Property
    public updated: Date;
    private updatedSubscription: Subscription;
    activeSufix = 'active';
    inactiveSufix = 'inactive';

    constructor(private projectService: ProjectService) { }

    ngOnInit() {
      this.updatedSubscription = this.projectService.updatedPipe$.subscribe( value => {
        this.updated = new Date()
      })
    }

    ngOnDestroy(): void {
       if(this.updatedSubscription) {
         this.updatedSubscription.unsubscribe();
     }
    }
}
